function getCountries() {
    let countriesJson = window.countriesJson
    if (countriesJson) {

        let orderedCountriesIds = Object.entries(countriesJson).sort(compareStrings),
            orderedCountries = [];

        orderedCountriesIds.map(function(country) {
            const countryData = countriesJson[country[0]]
            orderedCountries[country[0]] = countryData

        });

        setCountriesList(orderedCountries)

        $( ".CountriesSelector__Buttons .button" ).click(function() {
            const newUrl = $('#language-selector').val()
            updateGeoCookie()
            document.location.href = newUrl
        });
    }
}

function updateGeoCookie() {
    const currCountry = $( "#country-selector" ).val();
    _currCountry = currCountry;
    geolocatorClearCookie('check_cart');
    geolocatorUpdateCookie('geolocator_country',currCountry,false);
}

var collator = new Intl.Collator(undefined, {
  sensitivity: 'base'
});

function compareStrings(a, b) {
    return collator.compare(a[1].label,b[1].label);
}

function setCountriesList(countriesJson) {
    if(document.querySelector('#country-selector').options.length) return;
    const source = document.getElementById("countries-template").innerHTML;

    Object.keys(countriesJson).map(function(country) {
        const obj = {
            value: country,
            label: countriesJson[country].label,
            code: countriesJson[country].code
        }
        const template = Handlebars.compile(source);
        const html = template(obj);
        $('#country-selector').append(html);
    })

    const currentCountryCode = $('.country-selector--country').html();
    const countryLocale = window.countriesJson[currentCountryCode].code
    $('#country-selector option[data-code="'+countryLocale+'"]').attr('selected', 'selected');
    getCountryLanguages(countriesJson, countriesJson[currentCountryCode])

    $('#country-selector').on('change', function() {
        const country = $(this).val()
        getCountryLanguages(countriesJson, countriesJson[country])
    })
}

function getCountryLanguages(countriesJson, currentCountry) {
    $('#language-selector').empty();
    const countryLanguages = currentCountry.languages
    const source = document.getElementById("languages-template").innerHTML;
    Object.keys(countryLanguages).map(function(language) {
        const languageVal = countryLanguages[language].url
        const languageCode = countryLanguages[language].code

        if (languageVal !== '') {
            const obj = {
                value: languageVal,
                label: language,
                code: languageCode
            }
            const template = Handlebars.compile(source);
            const html = template(obj);
            $('#language-selector').append(html);
        }
    })

    setCurrentLanguage();
}

function setCurrentLanguage() {
    const languageSelector = $('#language-selector')
    const currentLang = languageSelector.data('language')
    const currentOptionLanguage = $('#language-selector option[data-code='+currentLang+']').val()
    if (currentOptionLanguage) {
        languageSelector.val(currentOptionLanguage)
    }
}
